import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { FilterContentComponent } from '@app/library/panes/filter-content/filter-content.component';
import { AbstractContentPane } from '@app/library/panes/models/abstract-content-pane';
import { HomeworkMiniComponent } from '@app/library/panes/my-classes-homework/homework-mini/homework-mini.component';
import { ChapterComponent } from '@core/components/chapter/chapter.component';
import { EmptyComponent, EmptyProps } from '@core/components/empty/empty.component';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { AccountService, AuthService, FeaturesService } from '@core/services';

import { IconComponent } from '@shared/icon/icon.component';
import { SkeletonComponent } from '@shared/skeleton/skeleton.component';
import { getMe } from '@store/reducers/profile.reducer';
import { FeatureEnum, User, UserStatusEnum } from 'lingo2-models';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-my-classes-homework-mini',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    RouterModule,

    OnUiButtonModule,
    OnUiCoverModule,
    OnUiCardMenuModule,
    NoContentStubComponent,
    FilterContentComponent,
    ChapterComponent,
    EmptyComponent,
    SkeletonComponent,
    HomeworkMiniComponent,
    IconComponent,
  ],
  templateUrl: './my-classes-homework.component.html',
  styleUrls: ['./my-classes-homework.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyClassesHomeworkComponent extends AbstractContentPane implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  protected features = inject(FeaturesService);

  public isGuest: boolean;
  categoryTabs = [
    { id: -1, code: 'all', title: 'my-classes.no-homeworks.filter.All' },
    { id: 1, code: 'verified', title: 'my-classes.no-homeworks.filter.Verified' },
    { id: 2, code: 'unverified', title: 'my-classes.no-homeworks.filter.Unverified' },
  ];
  subjects = [
    {
      id: 1,
      classRoomName: 'Классрум по английскому',
      subject: 'Английский язык',
      title: 'How to choose the right customer for your photo business?',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque ac nibh facilisis feugiat tristique ut turpis vitae, turpis. Feugiat et quis nunc tempor. Sed lacus in urna sed scelerisque.',
      date: new Date(),
      image: '/assets/images/new-design/Rectangle.png',
      exercises: [
        { image: '/assets/images/new-design/Rectangle.png' },
        { image: '/assets/images/new-design/Rectangle2.png' },
        { image: '/assets/images/new-design/Rectangle3.png' },
        { image: '/assets/images/new-design/Rectangle4.png' },
      ],
      teachers: [
        { image: '/assets/images/new-design/2.png' },
        { image: '/assets/images/new-design/3.png' },
        { image: '/assets/images/new-design/4.png' },
        { image: '/assets/images/new-design/5.png' },
      ],
    },
    {
      id: 1,
      subject: 'Испанский язык',
      classRoomName: 'Классрум по испанскому',
      title: 'How to choose the right customer for your photo business?',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque ac nibh facilisis feugiat tristique ut turpis vitae, turpis. Feugiat et quis nunc tempor. Sed lacus in urna sed scelerisque.',
      date: new Date(),
      image: '/assets/images/new-design/Rectangle3.png',
      exercises: [
        { image: '/assets/images/new-design/Rectangle.png' },
        { image: '/assets/images/new-design/Rectangle2.png' },
        { image: '/assets/images/new-design/Rectangle3.png' },
        { image: '/assets/images/new-design/Rectangle4.png' },
        { image: '/assets/images/new-design/Rectangle2.png' },
        { image: '/assets/images/new-design/Rectangle3.png' },
        { image: '/assets/images/new-design/Rectangle4.png' },
      ],
      teachers: [
        { image: '/assets/images/new-design/2.png' },
        { image: '/assets/images/new-design/3.png' },
        { image: '/assets/images/new-design/4.png' },
        { image: '/assets/images/new-design/5.png' },
      ],
    },
    {
      id: 1,
      subject: 'Испанский язык',
      classRoomName: 'Классрум по испанскому',
      title: 'How to choose the right customer for your photo business?',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque ac nibh facilisis feugiat tristique ut turpis vitae, turpis. Feugiat et quis nunc tempor. Sed lacus in urna sed scelerisque.',
      date: new Date(),
      image: '/assets/images/new-design/Rectangle3.png',
      exercises: [
        { image: '/assets/images/new-design/Rectangle.png' },
        { image: '/assets/images/new-design/Rectangle2.png' },
        { image: '/assets/images/new-design/Rectangle3.png' },
        { image: '/assets/images/new-design/Rectangle4.png' },
        { image: '/assets/images/new-design/Rectangle2.png' },
        { image: '/assets/images/new-design/Rectangle3.png' },
        { image: '/assets/images/new-design/Rectangle4.png' },
      ],
      teachers: [
        { image: '/assets/images/new-design/2.png' },
        { image: '/assets/images/new-design/3.png' },
        { image: '/assets/images/new-design/4.png' },
        { image: '/assets/images/new-design/5.png' },
      ],
    },
  ];
  selectedTab: any = { id: -1 };

  private _me: User;
  public showEmptyContent: boolean;
  public emptyContent: EmptyProps;
  public showSkeleton = true;

  ngOnInit() {
    this.store
      .select(getMe)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (me) => {
          this._me = me;
          this.isGuest = me?.status === UserStatusEnum.guest;
          this.emptyContent = {
            title: 'my-classes.no-homeworks.title',
            text: this.isAsIfTeacher ? 'my-classes.no-homeworks.text_teacher' : 'my-classes.no-homeworks.text',
            link: '/homework',
            link_label: '',
            link2: '/my-classes/homework',
            image: 'homework',
          };
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  onSelectItem(item): void {
    this.selectedTab = item;
  }

  public get showSection() {
    return this.features.isAvailable(FeatureEnum.my_classes_homework);
  }

  onNewHomework(): void {}

  protected onContentLoaded() {
    this.isVisible = true;
    this.showEmptyContent = this.pane.display_mode !== 'row';
    this.showSkeleton = false;
    this.detectChanges();
  }

  hasContent(): boolean {
    return true;
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public goSignup(e: Event) {
    if (this.isGuest) {
      this.authService.showAuthModal();
    }
  }

  public get isAsIfTeacher(): boolean {
    return AccountService.isAsIfTeacher(this._me);
  }

  public trackByFn(index) {
    return index;
  }
}
